import { ActionMenu, Button, icons } from '@portal/components'
import React from 'react'

import { useDQLEditorContext } from '../dqlEditor/context'

const { Refresh, ChevronUpDown } = icons

interface PollingIntervalMenuProps {
  pollingInterval: number | false
  setPollingInterval: (interval: number | false) => void
}

const intervals = {
  5000: '5 seconds',
  10000: '10 seconds',
  30000: '30 seconds',
  60000: '1 minute',
} as const

export default function PollingIntervalMenu({
  pollingInterval,
  setPollingInterval,
}: PollingIntervalMenuProps) {
  const { isLoadingCollections } = useDQLEditorContext()

  return (
    <ActionMenu
      groups={[
        {
          label: 'Refresh interval',
          items: [
            {
              label: 'Paused',
              onClick: () => setPollingInterval(false),
            },
            ...Object.entries(intervals).map(([value, label]) => ({
              label,
              onClick: () => setPollingInterval(Number(value)),
            })),
          ],
        },
      ]}
      trigger={
        <Button
          variant="default"
          className="pr-2"
          disabled={isLoadingCollections}
        >
          <Refresh size={16} className="mr-2" />
          {pollingInterval === false
            ? 'Paused'
            : intervals[pollingInterval as keyof typeof intervals]}
          <ChevronUpDown size={16} className="ml-2" />
        </Button>
      }
      align="end"
    />
  )
}
